import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Link } from 'components/navigation/Link/Link';
import { getAlaCartePurchaseFlowLink } from 'pages/AlaCartePurchase/alaCartePurchase.helper';
import { OVERVIEW_RING_UPDATE_SCORE } from 'global_types/ctaUpsell';

const UpdatedStatusLabel = props => {
  const {
    content = 'Updated',
    lastUpdateTime,
    showDaily,
    color = 'fontGray300',
    isUpdateScoreAvailable,
    redirectTo,
    alaCartePurchaseFlowType,
    score,
    hideOverviewDialScoreAndLabel,
    todayContainerLoading,
    isTransunion,
  } = props;
  const redirectLink =
    redirectTo ?? getAlaCartePurchaseFlowLink(alaCartePurchaseFlowType);

  return (
    <FlexContainer className="justify-center">
      <span className="margT5">
        {isUpdateScoreAvailable && (
          <Link
            to={redirectLink}
            className={'bold caption m-text-10 fontBlue100'}
            style={{ display: 'block' }}
            isInline
            isDisplayNone
          >
            {OVERVIEW_RING_UPDATE_SCORE}
          </Link>
        )}
        {!isUpdateScoreAvailable && (
          <Label type="caption m-text-10" bold color={color} tabIndex="-1">
            {`${
              score === null && hideOverviewDialScoreAndLabel
                ? 'Try Later'
                : todayContainerLoading && !props?.showDonut && !isTransunion
                ? 'mm/dd/yyyy'
                : `${content} ${showDaily ? 'Daily' : lastUpdateTime}`
            }`}
          </Label>
        )}
      </span>
    </FlexContainer>
  );
};

export default UpdatedStatusLabel;
